<!--
  邀请有奖
  lovi 2020-07-06
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('personal.invitationAwards')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="invite-wrap">
      <div class="content-wrap">
        <div class="slogan" :class="{ slogan_en: language == 'en' }">
          <img
            :src="
              require('@/assets/images/personal/invite/slogan_' +
                (language == 'en' ? 'en' : 'cn') +
                '.png')
            "
          />
        </div>
        <div class="qrCode-wrap">
          <div id="qrCode" class="column" ref="qrCode"></div>
          <van-button
            type="primary"
            class="icon-copy"
            :data-clipboard-text="url"
            @click="copyText"
          >
            {{ $t("common.copyLink") }}
          </van-button>
        </div>

        <div class="column">
          <h2>{{ $t("invite.myInvitationDetails") }}</h2>
          <div class="content invite">
            <div class="item">
              <span>{{ $t("invite.accumulated") }}</span>
              <p>
                {{
                  inviteData.invite_money
                    ? inviteData.invite_money.toFixed(2)
                    : "0.00"
                }}P
              </p>
            </div>
            <div class="item">
              <span>{{ $t("invite.successfulInvited") }}</span>
              <p>{{ inviteData.invite_count }}{{ $t("common.persons") }}</p>
            </div>
            <div class="item">
              <span>{{ $t("invite.successfulConsumption") }}</span>
              <p>{{ inviteData.invitees_consume }}{{ $t("common.persons") }}</p>
            </div>
          </div>
        </div>

        <div class="column">
          <h2>{{ $t("invite.friendsInvitation") }}</h2>
          <div class="content friend">
            <notice-bar
              v-if="inviteList.length"
              :data="inviteList"
              :limitMoveNum="5"
            >
              <ul>
                <li v-for="(item, index) in inviteList" :key="index">
                  <img :src="httpUrl + item.avatar" />
                  <span class="name text-hidden">{{ item.username }}</span>
                  <span class="phone">{{ item.phone }}</span>
                </li>
              </ul>
            </notice-bar>
          </div>
        </div>

        <div class="column">
          <h2>{{ $t("invite.rulesDescription") }}</h2>
          <div class="content rule">
            <pre v-html="inviteData.rule" />
          </div>
        </div>
      </div>
      <div class="bg-top"></div>
      <div class="bg-bottom"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import QRCode from "qrcodejs2";
import Clipboard from "clipboard";
import NoticeBar from "@/components/common/noticeBar";
export default {
  meta: {
    service: false
  },
  name: "invite",
  components: {
    NoticeBar
  },
  data() {
    return {
      inviteData: {},
      inviteList: [],
      url: ""
    };
  },
  created() {
    this._getInviteInfo();
  },
  mounted() {},
  computed: {
    ...mapGetters(["language"])
  },
  methods: {
    _getInviteInfo() {
      let vm = this;
      vm.$post("/app/user/InviteInfo", {}, { loading: true }).then(res => {
        console.log("InviteInfo", res);
        vm.inviteData = res;
        vm.inviteList = res.invitees;
        vm.url = vm.httpUrl + "/h5/#/share?id=" + res.user_id;
        vm._getQrcode(vm.url);
      });
    },
    _getQrcode(str) {
      // 生成二维码
      new QRCode(this.$refs.qrCode, {
        width: 160,
        height: 160,
        text: str // 内容
      });
    },
    copyText() {
      var clipboard = new Clipboard(".icon-copy");
      clipboard.on("success", e => {
        console.info("Action:", e.action);
        this.$toast(this.$t("common.copySuccess"));
        clipboard.destroy(); // 释放内存
      });
      clipboard.on("error", e => {
        console.info("error:", e.action);
        this.$toast(this.$t("common.browserNoCopy"));
        clipboard.destroy(); // 释放内存
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.invite-wrap {
  position: relative;
  min-height: 100vh;
  padding: 1.1px 0;
  background: url("@{images}personal/invite/bg_r.png") repeat;
  .bg-top {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 470px;
    background: url("@{images}personal/invite/bg_top.png") no-repeat top center;
    background-size: 100% auto;
  }
  .bg-bottom {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 200px;
    background: url("@{images}personal/invite/bg_bottom.png") no-repeat bottom
      center;
    background-size: 100% auto;
  }
  .content-wrap {
    padding-top: 44px;
    z-index: 1;
    position: relative;
    font-size: 14px;
  }
}

.slogan {
  text-align: center;
  padding-top: 30px;
  &.slogan_en {
    img {
      width: 314px;
    }
  }
  img {
    width: 220px;
  }
}

.column {
  margin: 15px;
  padding: 15px;
  background: #fff;
  color: #282f88;
  border: 8px solid rgba(128, 127, 239, 0.8);
  box-shadow: 0px 2px 21px 0px rgba(0, 0, 0, 0.24);
  border-radius: 10px;
  h2 {
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 1;
  }
  .content {
    margin-top: 15px;
  }
}

.qrCode-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 10px 0;
  .column {
    // min-width: 190px;
    // min-height: 190px;
  }
  /deep/.van-button--primary {
    padding: 0 20px;
    height: 34px;
    line-height: 34px;
    font-size: 16px;
    background: linear-gradient(
      0deg,
      rgba(75, 129, 239, 1) 0%,
      rgba(113, 71, 225, 1) 100%
    );
    border-radius: 4px 3px 3px 3px;
  }
}

.invite {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .item {
    position: relative;
    width: 33.33%;
    text-align: center;
    line-height: 1;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      border-left: 1px solid #424aac;
    }
    &:first-child::after {
      content: normal;
    }
    p {
      margin-top: 5px;
    }
  }
}
/deep/.van-notice-bar {
  // height: 160px;
  .van-notice-bar__content {
    width: 100%;
    .notice-swipe {
      height: 32px;
      line-height: 32px;
      .van-swipe-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 4px 0;
        img {
          width: 24px;
          height: 24px;
        }
        .name {
          margin: 0 8px;
          flex: 1;
        }
      }
    }
  }
}

.friend {
  height: 160px;
  overflow: hidden;
  ul li {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 4px 0;
    img {
      width: 24px;
      height: 24px;
    }
    .name {
      margin: 0 8px;
      flex: 1;
    }
  }
}

.rule {
  line-height: 1.5;
}
</style>
